import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { TownHallClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.MunicipioQuery],
  create: [SystemAuthorizations.MunicipioAdd],
  edit: [SystemAuthorizations.MunicipioUpdate],
  delete: [SystemAuthorizations.MunicipioDelete],
});

export const headCells: HeadCell<TownHallClient, keyof TownHallClient>[] = [
  {
    id: 'code',
    label: 'Zona',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaTownFilter = yup.object({
  code: yup.string().nullable().notRequired(),
  description: yup.string().nullable().notRequired(),
});
